import { render, staticRenderFns } from "./leftTableChart.vue?vue&type=template&id=124b59b8&scoped=true"
import script from "./leftTableChart.vue?vue&type=script&lang=js"
export * from "./leftTableChart.vue?vue&type=script&lang=js"
import style0 from "./leftTableChart.vue?vue&type=style&index=0&id=124b59b8&prod&lang=css"
import style1 from "./leftTableChart.vue?vue&type=style&index=1&id=124b59b8&prod&lang=less&scoped=true"
import style2 from "./leftTableChart.vue?vue&type=style&index=2&id=124b59b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124b59b8",
  null
  
)

export default component.exports